import { Component, OnInit, Input, ChangeDetectorRef, OnDestroy } from '@angular/core';

import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

import { messages, config } from 'app/constants';
import { CalculationService, DataService, FormatService, HelperService, HTTPService } from 'app/services';
import { currency } from 'app/constants/currency.constants';
import { UpdateCannedServiceDialogComponent } from '../update-canned-service-dialog/update-canned-service-dialog.component';
import { DeleteCategoryDialogComponent } from '../delete-category-dialog/delete-category-dialog.component';

import { ConfirmDismissDialogComponent } from 'app/modules/shared/components';
import { find, debounce } from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-fee-add',
  templateUrl: './fee-add.component.html',
  styleUrls: ['./fee-add.component.scss'],
})
export class FeeAddComponent implements OnInit, OnDestroy {
  @Input() isGlobalCategoryEnabled: boolean = false;
  @Input() isQboConnected: boolean = false;
  @Input() defaultTaxable: boolean = false;
  @Input() isOpenFromPO: boolean = false;
  @Input() qboItemRefs: any[] = [];
  @Input() isLoading: boolean = false; // don't set this key inside this component
  @Input() otherInfo: any = {};
  @Input() data: any = {};
  @Input() item: any = {};
  @Input() stock: any = {};
  @Input() feeId: string = '';
  @Input() isLocal: boolean = true;
  @Input() isCommissionPlanEnabled: boolean = false;
  @Input() orderServiceItemIndex: number = -1;
  @Input() orderServiceId: string = '';
  @Input() serviceItem: any = {};
  @Input() openFrom: string = 'catalog';
  @Input() orderId: string = '';
  @Input() order: any = {};
  @Input() isFeeAssociationEnabled: any = {};
  @Input() categories: any[] = [];
  @Input() categoryType: string = '';
  @Input() isPassThroughTaxEnable: boolean = false;
  @Input() isFinalizedRo: boolean = false;
  @Input() isPricingMatricesManagement: boolean = false;
  @Input() isPricingManagementEnable: boolean = false;
  @Input() isNewItemCategoriesEnable: boolean = false;
  @Input() isAttributeBasedPricingEnable: boolean = false;
  @Input() isSalesCodeEnabled: boolean = false;
  @Input() canEditClassifications: boolean = false;

  @Input('titleForCreate')
  set titleForCreate(title: any) {
    if (title) {
      this.fees.title = title;
      this.checkUniqueTitle();
    }
  }
  selectedTab: number = 0;
  activityLogs: any[] = [];
  checkUniqueCategory = debounce(this._checkUniqueCategory, 600);
  isSaving: boolean = false;
  isSearching: boolean = false;
  isSearchLoading: boolean = false;
  isOpenFromRO: boolean = false;
  defaultActiveState: boolean = false;
  updateGenericItem: boolean = false;
  isCreateMultiple: boolean = false;
  focus: any = {};
  errors: any = {};
  _qboItemRefs: any[] = [];
  itemResults: any[] = [];
  selectedItems: any[] = [];
  percentFeeSelectedItems = [];
  isTitleUnique: boolean = true;
  qboRefQuery: string = '';
  searchQuery: string = '';
  maxItems: string = '8';
  totalQuantity = 0;
  localizationSubscription: Subscription;
  totalFixedPrice = 0;
  totalFixedCost = 0;
  seeMore: boolean = false;
  usd: string = currency.USD;
  currentTabValues: any = {};
  checkUniqueTitle = debounce(this._checkUniqueTitle, 600);
  initalInputStates = <any>{};
  updatedInputStates = <any>{};
  fees: any = {
    title: '',
    titleFR: '',
    type: 'hazmatFee',
    qboRef: {},
    cost: '',
    price: '',
    count: '',
    totalCost: '',
    totalPrice: '',
    totalFeePrice: '',
    totalFeeCost: '',
    status: true,
    isTaxable: true,
    description: '',
    descriptionFR: '',
    internalNotes: '',
    displayHoursOnOrder: true,
    displayDescOnOrder: true,
    locationQboItemRefId: {},
    commissionable: true,
    isAssociateWithFee: false,
    isPassThroughTax: false,
    feeValueType: {},
    totalQuantity: 0,
    category: { name: '' },
  };
  itemMap: any = {};

  feeTypes: any[] = [
    {
      label: 'Fixed dollar fee',
      name: 'Fixed dollar fee',
      value: 'fixed',
      icon: 'far fa-usd-circle',
      placeholder: 'Fixed dollar fee',
    },
    {
      label: 'Percentage based fee',
      name: 'Percentage based fee',
      value: 'percent',
      icon: 'far fa-percent',
      placeholder: 'Percentage based fee',
    },
  ];
  categoryResults: any[] = [];
  config: any = config;
  isShowError: boolean = false;
  categoryName: any = '';
  categorId: any = '';
  isMultiLocationEnabled: boolean = false;
  isNewCategoriesEnabled: boolean = false;
  currentShopId: string = '';
  categoriesSuggestions: any[] = [];
  subCategoriesSuggestions: any[] = [];
  subSubCategoriesSuggestions: any[] = [];
  isLockedRO = false;
  categoriesSuggestionsResults: any[] = [];
  subCategoriesSuggestionsResults: any[] = [];
  subSubCategoriesSuggestionsResults: any[] = [];
  isPassThroughFet: boolean = false;
  loader = {
    category: false,
    subCategory: false,
    subSubCategory: false,
  };
  classificationPrivilegeMsg: string = messages.classificationPrivilegeMsg;
  //salesCodeOverideConfirm: boolean = false;
  defaultSalesCode: any = {};
  isAutoAssign: boolean = false;
  companyLocalization: boolean = false;
  currentLang: string = 'en';
  constructor(
    private httpService: HTTPService,
    private formatService: FormatService,
    private dataService: DataService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private calculationService: CalculationService,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.dataService.isNewItemCategoriesEnable) this.getAllCategories();
    this.fees.feeValueType = this.feeTypes[0];
    this.itemMap = {};

    this.getLocalizationFlags();
    if (this.feeId) {
      this.getLogs();
    }

    if (this.order && this.order.services && this.order.services.length) {
      this.order.services.forEach(({ items }) => {
        if (items && items.length) {
          items.forEach((item: any) => {
            const { itemInternalReference } = item;

            this.itemMap[itemInternalReference] = item;
          });
        }
      });
    }

    if (this.isOpenFromRO) {
      this.isLockedRO = this.dataService.isLockedRO;
    }
    if (this.openFrom !== 'catalog' && this.openFrom !== 'parts-ordering') {
      this.searchSuggestion('');
    }
  }

  getLocalizationFlags() {
    const { isMultiLocationEnabled } = this.helperService.getCompany();
    this.localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        if (!isMultiLocationEnabled) {
          this.httpService.getCompanyPreferredLanguage().then((res: any) => {
            const lang = res.preferredLanguage
            if (lang) {
              this.currentLang = lang.toLowerCase();
            }
          });
        } else {
          this.httpService.getCompanyDetails(this.helperService.getCompany().companyId).then((company: any) => {
            const lang = company.shop.preferredLanguage;
            if (lang) this.currentLang = lang.toLowerCase();
          })
        }
      }
    })
  }

  ngOnDestroy() {
    if (this.localizationSubscription) this.localizationSubscription.unsubscribe();
  }

  getLogs() {
    const query = <any>{};
    query.entityId = this.feeId;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        console.log(data);
        if (data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  _checkUniqueCategory() {
    this.httpService.isCategoryUnique({ name: this.categoryName.trim(), type: 'item' }, this.categorId).then(
      (res) => {
        if (!res) {
          this.isShowError = true;
        } else {
          this.isShowError = false;
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  handleChangeCategory(name: string, value) {
    this.categoryName = value;
    this.checkUniqueCategory();
  }

  ngOnChanges(change: any) {
    const { isLoading } = change;

    if (isLoading) {
      if (isLoading.previousValue && !isLoading.currentValue) {
        if (!this.feeId) {
          this.fees.isTaxable = this.defaultTaxable;
        }
        this.currentShopId = localStorage.getItem('currentShop');
        const { isMultiLocationEnabled } = this.helperService.getCompany();
        this.isMultiLocationEnabled = isMultiLocationEnabled;
        this.isNewCategoriesEnabled = this.dataService.isNewItemCategoriesEnable;
        this.setItemDetails(this.item);
        this.setFeeData();
        this.setCategories(this.categories);
        this._qboItemRefs = this.helperService.deepCopy(this.qboItemRefs);
        this.isSaving = false;
      }
    }
  }

  setCategories(categories: any[]) {
    this.categoryResults = [...categories];
  }

  _checkUniqueTitle() {
    this.httpService.isItemTitleUnique({ title: this.fees.title.trim(), type: 'hazmatFee' }, this.feeId).then(
      (res) => {
        if (!res) {
          this.errors.title = 'Fees name must be unique';
          this.isTitleUnique = false;
          this.helperService.showToaster('error', 'Fees name must be unique');
        } else {
          this.errors.title = '';
          this.isTitleUnique = true;
        }
      },
      (err) => {
        console.error(err);
      }
    );
  }

  setFeeData() {
    if (this.serviceItem && this.serviceItem.itemId) {
      this.fees = {
        ...this.fees,
        number: this.serviceItem.code ? this.serviceItem.code : this.fees.number,
        description: this.serviceItem.description,
        descriptionFR: this.serviceItem.descriptionFR,
        internalNotes: this.serviceItem.internalNotes,
        isTaxable: this.serviceItem.isTaxable,
        status: true,
      };

      if (this.serviceItem.hasOwnProperty('isPassThroughTax')) {
        this.fees.isPassThroughTax = this.serviceItem.isPassThroughTax;
      }

      if (this.serviceItem.hasOwnProperty('title')) {
        this.fees.title = this.serviceItem.title;
      }

      if (this.serviceItem.hasOwnProperty('titleFR')) {
        this.fees.titleFR = this.serviceItem.titleFR;
      }

      if (this.serviceItem.hasOwnProperty('count')) {
        this.fees.count = this.serviceItem.count;
      }

      if (this.serviceItem.hasOwnProperty('salesCode') && this.serviceItem.salesCode?.salesCodeId) {
        this.fees.salesCode = this.serviceItem.salesCode;
      }

      if (this.serviceItem.feeValueType === 'percent') {
        if (this.serviceItem.hasOwnProperty('pricePercent')) {
          this.fees.price = this.serviceItem.pricePercent;
        }

        if (this.serviceItem.hasOwnProperty('costPercent')) {
          this.fees.cost = this.serviceItem.costPercent;
        }
      } else {
        if (this.serviceItem.hasOwnProperty('price')) {
          this.fees.price = this.serviceItem.price;
        }

        if (this.serviceItem.hasOwnProperty('cost')) {
          this.fees.cost = this.serviceItem.cost;
        }
      }

      if (this.serviceItem.hasOwnProperty('displayHoursOnOrder')) {
        this.fees.displayHoursOnOrder = this.serviceItem.displayHoursOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('displayDescOnOrder')) {
        this.fees.displayDescOnOrder = this.serviceItem.displayDescOnOrder;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        this.fees.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('commissionable')) {
        this.fees.commissionable = this.serviceItem.commissionable;
      }

      if (this.serviceItem.hasOwnProperty('category') && this.serviceItem.category) {
        // this.fees.category = {
        //   ...this.serviceItem.category,
        //   _id: this.serviceItem.category.categoryId,
        // };
        if (this.isNewCategoriesEnabled) {
          this.fees.category = {
            ...this.serviceItem.category,
          };
        } else {
          this.fees.category = {
            ...this.fees.category,
            ...this.serviceItem.category,
            _id: this.serviceItem.category.categoryId,
          };
        }
      }

      if (this.serviceItem.hasOwnProperty('feeValueType')) {
        if (this.serviceItem.feeValueType) {
          this.fees.feeValueType = find(this.feeTypes, { value: this.serviceItem.feeValueType });
        }
      }

      if (this.openFrom === 'parts-ordering') {
        if (this.serviceItem.hasOwnProperty('cost')) {
          this.fees.cost = this.serviceItem.cost;
        }

        if (this.serviceItem.hasOwnProperty('count')) {
          this.fees.count = this.serviceItem.count;
        }

        this.fees.totalCost = this.fees.cost * this.fees.count;
      }

      if (this.serviceItem.qboId) {
        this.fees.itemRef = { qboId: this.serviceItem.qboId };
        this.setItemRef();
      }

      this.fees.associatedItems = [];
      this.selectedItems = [];

      if (this.serviceItem.associatedItemsInternalReferences) {
        this.serviceItem.associatedItemsInternalReferences.forEach((id: string) => {
          if (this.itemMap[id]) {
            this.fees.associatedItems.push({ itemId: this.itemMap[id] });
            this.selectedItems.push(this.itemMap[id]);
          }
        });
      }

      if (this.serviceItem && this.selectedItems.length) {
        if (this.openFrom === 'RO' && this.itemResults && this.itemResults.length) {
          this.itemResults = this.itemResults.filter((el) => !this.selectedItems.find((e) => (e && e.itemInternalReference) === (el && el.itemInternalReference)));
        }
      }

      this.fees.isAssociateWithFee = this.selectedItems.length > 0;
      this.fees.totalCost = this.serviceItem.cost * this.serviceItem.count;
      this.fees.totalPrice = this.serviceItem.price * this.serviceItem.count;

      this.calculateTotalQuantity();
      this.calculateTotalPriceAndCost();
    }
  }

  logPXGaingSightCustomEvent(res: any) {
    if (res?.salesCode?.salesCodeId && res?.salesCode?.salesCodeId !== this.defaultSalesCode?.salesCodeId) {
      const logInfo = {
        itemName: res?.title || res?.name,
        salesCodeName: res?.salesCode?.title,
        salesCode: res?.salesCode?.shortName,
        category: res?.category?.name,
        subCategory: res?.category?.subCategoryName,
        itemType: res?.type,
        assignmentType: this.isAutoAssign ? 'Auto' : 'User has assigned sales code directly from the Catalog/RO',
      };
      this.helperService.logPXGaingSightEvent('Sales code assigned to an item', logInfo);
    }
  }

  setItemDetails(fees: any) {
    this.currentTabValues = fees;

    if (this.feeId && fees) {
      this.isPassThroughFet = fees?.isPassThroughFet || false;
      this.fees = {
        title: fees.title,
        titleFR: fees.titleFR,
        type: 'hazmatFee',
        qboRef: {},
        salesCode: fees.salesCode,
        itemRef: { qboId: fees.qboId },
        locationQboItemRefId: fees.locationQboItemRefId || {},
        cost: fees.cost,
        price: fees.price,
        count: fees.count,
        status: fees.status,
        isTaxable: fees.isTaxable,
        description: fees.description,
        descriptionFR: fees.descriptionFR,
        internalNotes: fees.internalNotes,
        commissionable: fees.commissionable,
        displayHoursOnOrder: fees.displayHoursOnOrder,
        displayDescOnOrder: fees.displayDescOnOrder,
        totalFixedCost: this.totalFixedCost,
        totalFixedPrice: this.totalFixedPrice,
        totalFeeCost: fees.totalFeeCost,
        totalFeePrice: fees.totalFeePrice,
        isPassThroughTax: fees.isPassThroughTax,
        category: fees.category || {},
      };

      if (this.isNewCategoriesEnabled) {
        this.fees.category = fees.category;
      }

      this.fees.totalCost = fees.cost * fees.count;
      this.fees.totalPrice = fees.price * fees.count;
      this.defaultActiveState = fees.status;
      this.fees.totalFeeCost = (fees.cost / 100) * fees.totalFixedCost;
      this.fees.totalFeePrice = (fees.price / 100) * fees.totalFixedPrice;

      if (fees.feeValueType === 'percent') {
        this.fees.feeValueType = this.feeTypes[1];
      } else {
        this.fees.feeValueType = this.feeTypes[0];
      }

      if (this.isSalesCodeEnabled) {
        this.defaultSalesCode = this.helperService.deepCopy(fees?.salesCode);
      }

      if (fees.associatedItems && fees.associatedItems.length > 0) {
        // bug ALP-7489 temp fix should not retrun from API the inactive items
        // this.fees.isAssociateWithFee = true;
        // let getElementFromArray = fees.associatedItems.map((itm) => {
        //     return itm.itemId;
        // });
        const getElementFromArray: any = [];
        fees.associatedItems.forEach((itm: any) => {
          if (itm.itemId && itm.itemId.status) {
            getElementFromArray.push(itm.itemId);
          }
        });
        this.selectedItems = getElementFromArray;
        if (this.selectedItems && this.selectedItems.length > 0) {
          this.fees.isAssociateWithFee = true;
        } else {
          this.fees.isAssociateWithFee = false;
        }

        this.calculateTotalQuantity();
        this.calculateTotalPriceAndCost();
      }
    } else {
      this.fees.commissionable = this.dataService.isCommissionFees;
    }

    this.initalInputStates = this.helperService.deepCopy(this.fees);
    this.setItemRef();
    this.isSaving = false;
  }

  /** Set Item Ref */
  setItemRef() {
    if (this.fees && this.fees.itemRef && this.fees.itemRef.qboId && this.qboItemRefs.length) {
      this.fees.qboRef = find(this.qboItemRefs, {
        qboId: this.fees.itemRef.qboId,
      });
    }
    // if its an multiLocation tenant check that location level ref is saved then override the ref
    if (this.isMultiLocationEnabled) {
      if (this.fees && this.fees.locationQboItemRefId && this.fees.locationQboItemRefId[this.currentShopId] && this.qboItemRefs.length) {
        const refId = this.fees.locationQboItemRefId[this.currentShopId];
        this.fees.qboRef = find(this.qboItemRefs, {
          qboId: refId,
        });
      }
    }
  }

  getQboRefs() {
    this.isSearching = true;
    this.httpService
      .getQBOItemRefs(this.qboRefQuery)
      .then(
        (qboItemRefs: any) => {
          if (qboItemRefs && qboItemRefs.items) {
            this.qboItemRefs = [...qboItemRefs.items];
            this._qboItemRefs = [...qboItemRefs.items];
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSearching = false;
      });
  }

  calculateTotal() {
    const { cost, price } = this.fees;
    /* Fix for ALP-7555 -- start */
    let { count } = this.fees;

    if (this.fees.isAssociateWithFee) {
      count = this.totalQuantity;
    }
    /* Fix for ALP-7555 -- end */

    if (!isNaN(count) && !isNaN(cost)) {
      this.fees.totalCost = this.calculationService.roundOff(Number(count) * Number(cost));
    }

    if (!isNaN(count) && !isNaN(price)) {
      this.fees.totalPrice = this.calculationService.roundOff(Number(count) * Number(price));
    }

    if (this.isPassThroughTaxEnable && this.fees.isPassThroughTax) {
      this.fees.totalCost = this.calculationService.roundOff(Number(count) * Number(price));
      this.fees.totalPrice = this.calculationService.roundOff(Number(count) * Number(price));
    }
  }

  openAssignSalesCodeDialog() {
    if (!this.canEditClassifications && this.openFrom !== 'RO') {
      return;
    }
    const data = {
      item: this.fees,
      openFrom: 'fees-modal',
    };
    this.dataService.sendData(this.dataService.typeDialog('open-sales-code-assign-modal', 'fees-modal', null, null, data));
  }

  displaySalesCodeTitle() {
    return this.helperService.displaySalesCodeTitle(this.fees.salesCode, this.fees.category);
  }

  resetData() {
    this.fees = {
      title: '',
      titleFR: '',
      type: 'hazmatFee',
      qboRef: {},
      cost: '',
      price: '',
      count: '',
      totalCost: '',
      totalPrice: '',
      totalFeeCost: '',
      totalFeePrice: '',
      status: true,
      isTaxable: this.defaultTaxable,
      description: '',
      descriptionFR: '',
      internalNotes: '',
      displayHoursOnOrder: true,
      displayDescOnOrder: true,
      isAssociateWithFee: false,
      feeValueType: this.fees.feeValueType,
    };
    this.focus.name = true;
    this.errors = {};
    this.feeId = null;
    this.selectedItems = [];
    this.totalQuantity = 0;
  }

  handleFocus(type: string) {
    this.focus[type] = true;
    this.errors[type] = '';

    if (type === 'subCategory' && !this.subCategoriesSuggestionsResults?.length) {
      if (this.fees.category?.categoryId) this.getSubCategories(this.fees.category);
    }

    if (type === 'subSubCategory' && !this.subSubCategoriesSuggestionsResults?.length) {
      if (this.fees.category?.categoryId && this.fees.category?.subCategoryId) this.getSubSubCategories(this.fees.category, this.fees.category);
    }
  }

  handleBlur(type: string) {
    this.focus[type] = false;

    if (['cost', 'price', 'count'].includes(type)) {
      this.calculateTotal();
    }

    if (type === 'title' && this.fees.title) {
      this.checkUniqueTitle();
    }
    if (type === 'titleFR' && this.fees.titleFR) {
      this.checkUniqueTitle();
    }
  }

  handleClear(type = '') {
    if (type === 'category') {
      this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
    } else if (type === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
    } else if (type === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestionsResults);
    } else {
      this.qboItemRefs = [...this._qboItemRefs];
    }
  }

  handleQboRefSearch(query: string = '') {
    this.qboRefQuery = query;
    this.getQboRefs();
  }

  handleChange(key: string, value: any) {
    if (key === 'price' || key === 'description' || key === 'descriptionFR' || key === 'isTaxable' || key === 'internalNotes' || key === 'isPassThroughTax' || key === "count") {
      this.updatedInputStates[key] = this.initalInputStates[key] != value;
    }

    if (key === 'cost') {
      this.fees.totalFeeCost = this.totalFixedCost * (value / 100);
      this.calculateTotal();
    }

    if (key === 'price') {
      this.fees.totalFeePrice = this.totalFixedPrice * (value / 100);
      this.calculateTotal();
    }

    if (this.fees.isPassThroughTax && key === 'price' && this.isPassThroughTaxEnable) {
      this.fees.cost = value;
      this.fees.totalFeeCost = this.totalFixedCost * (value / 100);
      this.fees.totalFeePrice = this.totalFixedPrice * (value / 100);
      this.calculateTotal();
    }

    if (key === 'feeValueType') {
      if (this.currentTabValues && value.value === this.currentTabValues.feeValueType) {
        this.fees.cost = this.currentTabValues.cost;
        this.fees.price = this.currentTabValues.price;
        this.calculateTotal();
      } else {
        this.fees.cost = '';
        this.fees.price = '';
      }

      this.fees.feeValueType = value;
      if (value && value.value === 'fixed') {
        // this.fees.isPassThroughTax = false;
        this.fees.isAssociateWithFee = false;
        this.totalQuantity = 0;
        this.percentFeeSelectedItems = this.helperService.deepCopy(this.selectedItems);
        this.selectedItems = [];
        this.calculateTotalQuantity();
        this.calculateTotalPriceAndCost();
        this.calculateTotal();
      } else {
        this.selectedItems = this.helperService.deepCopy(this.percentFeeSelectedItems);
        this.calculateTotalQuantity();
        this.calculateTotalPriceAndCost();
        this.calculateTotal();
      }
    }

    this.fees[key] = value;

    if (['displayDescOnOrder', 'displayHoursOnOrder', 'status'].includes(key)) {
      this.cdr.detectChanges();
    }

    if (key === 'isPassThroughTax' && value) {
      this.fees.price = this.fees.cost;
      this.fees.cost = this.fees.price;
      this.calculateTotal();

      if (this.isPassThroughTaxEnable && this.fees.isPassThroughTax) {
        this.helperService.showToaster('success', messages.passthroughFeesUpdate);
      }
    }

    if (this.isPassThroughTaxEnable && this.fees.isPassThroughTax) {
      this.fees.isTaxable = false;
      this.fees.commissionable = false;
    }

    // if (this.fees.title) {
    //   this.checkUniqueTitle();
    // }
  }

  handleClose() {
    this.dynamicDialogRef.close({ isSuccess: false });
  }

  handleSubmit() {
    if (this.fees.feeValueType.value === 'fixed' && this.fees.isAssociateWithFee) {
      this.fees.count = this.totalQuantity;
      this.fees.totalQuantity = this.totalQuantity;
    }

    if (!this.isValid()) return;

    if (this.feeId) {
      this.handleUpdateFees();
    } else {
      this.handleCreateFees();
    }
  }

  handleCreateFees() {
    this.isSaving = true;
    const item = this.helperService.deepCopy(this.fees);
    if (this.isOpenFromPO || this.orderServiceId) {
      if (this.isSalesCodeEnabled && !this.canEditClassifications) {
        this.fees.salesCode = this.defaultSalesCode;
      }
    }
    this.httpService
      .createItem(this.formatFeeData(this.fees))
      .then(
        (res: any) => {
          this.helperService.showToaster('success', messages.feesCreation);
          this.dataService.sendData(this.dataService.typePassData('fee-list', {}));

          if (this.isOpenFromPO || this.orderServiceId) {
            if (this.isSalesCodeEnabled && !this.canEditClassifications) {
              res.salesCode = item?.salesCode;
            }
          }

          if (this.isSalesCodeEnabled) {
            this.logPXGaingSightCustomEvent(res);
          }

          // Sending data to RO
          if (this.orderServiceId) {
            this.dataService.sendData(
              this.dataService.typePassData('ro-service-item', {
                ...res,
                actionType: 'create',
                serviceId: this.orderServiceId,
                index: this.orderServiceItemIndex,
                totalFixedCost: this.totalFixedCost,
                totalFixedPrice: this.totalFixedPrice,
                isPassThroughTax: this.fees.isPassThroughTax,
                associatedItemsInternalReferences: (this.selectedItems || []).map(({ itemInternalReference }) => itemInternalReference),
              })
            );
          } else if (this.openFrom === 'parts-ordering') {
            this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...res, actionType: 'create' }));
          } else if (this.openFrom === 'cannedService' || this.openFrom === 'catalog') {
            this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...res, actionType: 'create' }));
          }

          // Cleaning and closing the dialog
          if (!this.isCreateMultiple) {
            this.dynamicDialogRef.close();
          } else {
            this.resetData();
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSaving = false;
      });
  }

  handleUpdateFees() {
    if (this.isSaving) return;

    this.isSaving = true;

    if (this.orderServiceId && !this.updateGenericItem) {
      this.isSaving = false;
      this.dynamicDialogRef.close();

      if (this.isSalesCodeEnabled && this.fees?.salesCode?.salesCodeId && this.serviceItem?.salesCode?.salesCodeId !== this.fees?.salesCode?.salesCodeId) {
        this.logPXGaingSightCustomEvent(this.fees);
      }

      if (this.feeId) {
        this.fees._id = this.feeId;
      }

      if (this.fees && this.fees.qboRef && this.fees.qboRef.qboId) {
        this.fees.qboId = this.fees.qboRef.qboId;
      }

      this.dataService.sendData(
        this.dataService.typePassData('ro-service-item', {
          ...this.formatFeeData(this.fees),
          totalFixedCost: this.totalFixedCost,
          totalFixedPrice: this.totalFixedPrice,
          associatedItemsInternalReferences: (this.selectedItems || []).map(({ itemInternalReference }) => itemInternalReference),
          actionType: 'update',
          isLocal: true,
          serviceId: this.orderServiceId,
          index: this.orderServiceItemIndex,
          isPassThroughTax: this.fees.isPassThroughTax,
        })
      );
      this.dataService.sendData(
        this.dataService.typePassData('po-service-item', {
          ...this.fees,
          actionType: 'update',
          serviceId: this.orderServiceId,
          index: this.orderServiceItemIndex,
        })
      );
    } else if (this.openFrom === 'parts-ordering') {
      this.isSaving = false;
      this.dynamicDialogRef.close();
      this.dataService.sendData(
        this.dataService.typePassData('parts-ordering-item', {
          fees: { ...this.formatFeeData(this.fees) },
          actionType: 'update',
          otherInfo: this.otherInfo,
        })
      );
    } else {
      this.isSaving = true;
      this.httpService
        .updateItem(this.formatFeeData(this.fees))
        .then(
          (fee: any) => {
            this.helperService.showToaster('success', messages.feesUpdate);
            this.dynamicDialogRef.close();
            this.dataService.sendData(this.dataService.typePassData('fee-list', {}));

            if (this.isSalesCodeEnabled) {
              this.logPXGaingSightCustomEvent(fee);
            }

            if (this.orderServiceId) {
              this.dataService.sendData(
                this.dataService.typePassData('ro-service-item', {
                  ...fee,
                  actionType: 'update',
                  serviceId: this.orderServiceId,
                  index: this.orderServiceItemIndex,
                })
              );
            } else if (this.openFrom === 'cannedService') {
              this.dataService.sendData(this.dataService.typePassData('canned-service-item', { ...fee, actionType: 'create' }));
            }

            if (fee.feeValueType === 'fixed') {
              // Open update canned service dialog
              let isUpdated = false;

              if (this.fees.price && this.initalInputStates.price != this.fees.price) {
                isUpdated = true;
                this.updatedInputStates.price = this.fees.price;
              }

              if (this.fees.description && this.initalInputStates.description != this.fees.description) {
                isUpdated = true;
                this.updatedInputStates.description = this.fees.description;
              }

              if (this.fees.internalNotes && this.initalInputStates.internalNotes != this.fees.internalNotes) {
                isUpdated = true;
                this.updatedInputStates.internalNotes = this.fees.internalNotes;
              }

              if (this.fees.isTaxable && this.initalInputStates.isTaxable != this.fees.isTaxable) {
                isUpdated = true;
                this.updatedInputStates.isTaxable = this.fees.isTaxable;
              }

              if (this.fees.cost && this.initalInputStates.cost != this.fees.cost) {
                isUpdated = true;
                this.updatedInputStates.cost = this.fees.cost;
              }

              if (Object.values(this.updatedInputStates).includes(true) || isUpdated) {
                if (this.updatedInputStates.cost && Object.keys(this.updatedInputStates).length === 1) {
                  this.updateCannedService(fee);
                } else {
                  fee = {
                    ...fee,
                    costRate: fee.cost,
                  };
                  this.openUpdateCannedServicesDialog(fee);
                }
              }
            }
          },
          (err) => {
            this.helperService.showToaster('error', err);
          }
        )
        .finally(() => {
          this.isSaving = false;
        });
    }
  }

  async updateCannedService(data) {
    const cannedServices = await this.httpService.getCannedServicesByItem(this.feeId);

    if (cannedServices.length === 0) {
      return;
    }
    const payload = <any>{
      services: cannedServices.map((c: any) => {
        return {
          _id: c._id,
          itemType: c.itemType,
        };
      }),
      itemId: this.feeId,
      isPassThroughTax: data.isPassThroughTax,
    };
    payload.costRate = data.cost;
    // payload.costRate = data.costRate;
    // payload.costEstimatedHours = data.costEstimatedHours;
    await this.httpService.updateCannedServicesByItem(payload);
  }

  isValid() {
    const { title, titleFR, cost, price, count, feeValueType } = this.fees;
    let isValid = true;
    if (cost === '') {
      this.errors.cost = 'Cost required*';
      isValid = false;
    }

    if (price === '') {
      this.errors.price = 'Price required*';
      isValid = false;
    }

    if (count === '' && feeValueType.value === 'fixed') {
      this.errors.count = 'Default qty required*';
      isValid = false;
    }

    if (this.companyLocalization && this.currentLang === 'fr') {
      if (!titleFR) {
        this.errors.titleFR = 'French Title required*';
        this.helperService.showToaster('error', 'Fees french title is required');
        isValid = false;
      }
    } else {
      if (!title?.trim()) {
        this.errors.title = 'Title required*';
        this.helperService.showToaster('error', 'Fees title is required');
        isValid = false;
      }
      if (!this.isTitleUnique) {
        this.errors.title = 'Fee name must be unique';
        this.helperService.showToaster('error', 'Fee name must be unique');
        isValid = false;
      }
    }

    return isValid;
  }

  formatFeeData(data: any) {
    let associatedList = [];

    if ((this.fees.feeValueType.value === 'fixed' && this.fees.isAssociateWithFee) || this.fees.feeValueType.value === 'percent') {
      associatedList = this.selectedItems.map((itm) => {
        return {
          itemId: itm._id,
        };
      });
    }

    const fees = { ...data };

    if (fees.cost) {
      fees.cost = Number(fees.cost);
    }

    if (fees.price) {
      fees.price = Number(fees.price);
    }

    fees.notes = fees.description;
    fees.internalNotes = fees.internalNotes;

    if (this.isNewCategoriesEnabled && this.isSalesCodeEnabled) {
      if (this.fees.salesCode && this.fees.salesCode?.salesCodeId) fees.salesCode = this.fees.salesCode;
      else fees.salesCode = {};
    }

    if (this.fees.isAssociateWithFee || (this.fees.feeValueType && this.fees.feeValueType.value === 'percent')) {
      fees.count = 0;
      (this.selectedItems || []).forEach(({ count }) => {
        fees.count += Number(count);
      });
    }

    fees.associatedItems = associatedList;
    fees.feeValueType = fees.feeValueType.value;

    if (data.qboRef && data.qboRef.qboId) {
      fees.qboId = data.qboRef.qboId;
      fees.qboItemRefId = data.qboRef.qboId;
      if (this.isMultiLocationEnabled && fees.locationQboItemRefId && fees.locationQboItemRefId[this.currentShopId]) {
        fees.locationQboItemRefId[this.currentShopId] = fees.qboId;
      }
    }

    if (this.feeId) {
      fees._id = this.feeId;
    }

    if (this.isNewItemCategoriesEnable && this.isSalesCodeEnabled) {
      fees.isAutoAssign = this.isAutoAssign;
    }

    return fees;
  }

  onROSelect(query) {
    this.selectedItems.unshift(query);
    this.calculateTotalQuantity();
    this.calculateTotalPriceAndCost();
    this.calculateTotal();
    this.itemResults = this.itemResults.filter((itemResult) => itemResult._id !== query._id);
    // this.itemResults = [];
  }

  onSearchClear() {
    this.itemResults = [];
    if (this.openFrom !== 'catalog') {
      this.searchSuggestion('');
    }
  }

  onSearchEnter(query: string) { }

  onSearchItem(name: string, query: string) {
    if (name === 'category') {
      this.categoriesSuggestionsResults = this.categoriesSuggestions.filter(({ categoryName }) => categoryName && new RegExp(`${query}`, 'gi').test(categoryName));
    } else if (name === 'subCategory') {
      this.subCategoriesSuggestionsResults = this.subCategoriesSuggestions.filter(({ subCategoryName }) => subCategoryName && new RegExp(`${query}`, 'gi').test(subCategoryName));
    } else if (name === 'subSubCategory') {
      this.subSubCategoriesSuggestionsResults = this.subSubCategoriesSuggestions.filter(({ subSubCategoryName }) => subSubCategoryName && new RegExp(`${query}`, 'gi').test(subSubCategoryName));
    }
  }

  removeSelectedRO(item) {
    this.itemResults.push(item);
    this.selectedItems = this.selectedItems.filter((selectedItem) => selectedItem._id !== item._id);
    if (this.fees && this.fees.feeValueType && this.fees.feeValueType.value !== 'fixed') {
      this.percentFeeSelectedItems = this.percentFeeSelectedItems.filter((selectedItem) => selectedItem._id !== item._id);
    }
    // this.selectedItems.splice(index, 1);
    this.calculateTotalQuantity();
    this.calculateTotalPriceAndCost();
    this.calculateTotal();
  }

  showAllSelectedItems() {
    this.maxItems = this.maxItems + this.selectedItems.length;
    this.seeMore = true;
  }

  hideSelectedItem() {
    this.maxItems = '8';
    this.seeMore = false;
  }

  calculateTotalQuantity() {
    this.totalQuantity = this.selectedItems.reduce(function (acc, val) {
      return acc + val.count;
    }, 0);
  }

  calculateTotalPriceAndCost() {
    this.totalFixedPrice = this.selectedItems.reduce(function (acc, val) {
      if (!isNaN(val.count) && !isNaN(val.price)) {
        let Totalprice = Number(val.count * val.price);
        return acc + Totalprice;
      }
    }, 0);

    this.totalFixedCost = this.selectedItems.reduce(function (acc, val) {
      if (!isNaN(val.count) && !isNaN(val.cost)) {
        let TotalCost = Number(val.count) * Number(val.cost);
        return acc + TotalCost;
      }
    }, 0);
    this.fees.totalFeeCost = this.totalFixedCost * (this.fees.cost / 100);
    this.fees.totalFeePrice = this.totalFixedPrice * (this.fees.price / 100);
  }

  async searchSuggestion(query: string) {
    this.isSearchLoading = true;

    try {
      let data: any;

      if (this.openFrom === 'catalog') {
        data = await this.httpService.getItems({
          limit: 100,
          partAssociationSearch: true,
          search: query.trim(),
          activeStatus: true,
        });
      } else if (this.openFrom === 'RO' && this.orderId) {
        data = await this.httpService.searchOrderItems(this.orderId, query.trim());
      }

      this.itemResults = [];

      if (data?.records) {
        if (this.selectedItems.length > 0) {
          if (this.openFrom === 'RO') {
            this.itemResults = data.records.filter((el) => !this.selectedItems.find((e) => (e && e.itemInternalReference) === (el && el.itemInternalReference)));
          } else {
            this.itemResults = data.records.filter((el) => !this.selectedItems.find((e) => (e && e._id) === (el && el._id)));
          }
        } else {
          this.itemResults = data.records;
        }
      }
    } catch (err) {
      this.isSearchLoading = false;
      this.helperService.showToaster('error', err);
    } finally {
      this.isSearchLoading = false;
    }
  }

  async openUpdateCannedServicesDialog(data) {
    try {
      const cannedServices = await this.httpService.getCannedServicesByItem(data._id);

      if (cannedServices.length === 0) return;

      // open update canned service dialog
      this.dialogService.open(UpdateCannedServiceDialogComponent, {
        width: '50%',
        styleClass: 'add-dialog add-part update-canned overflow-initial',
        showHeader: false,
        data: {
          part: data,
          cannedServices,
          updatedFields: Object.keys(this.updatedInputStates).filter((key) => {
            try {
              return this.updatedInputStates[key];
            } catch (e) {
              return false;
            }
          }),
        },
      });
    } catch (error) {
      this.helperService.showToaster('error', error);
    }
  }

  deleteCategoryDialog(e) {
    this.httpService
      .getAllCategories(e._id)
      .then((data: any) => {
        if (data.length) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'fees',
              isOnlyDelete: false,
              count: data.length,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.fees && this.fees.category?.name === name) {
                this.fees.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        } else if (data.length === 0) {
          const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
            width: '1200px',
            styleClass: 'add-dialog overflow-initial delete-category-dialog',
            showHeader: false,
            data: {
              selectedCategory: e,
              categoryList: this.categoryResults,
              type: 'fees',
              isOnlyDelete: true,
              count: 0,
            },
          });
          const onClose = ref.onClose.subscribe(({ isSuccess, data, selectedName }) => {
            if (isSuccess) {
              const { categoryId, name } = data.category;
              if (this.fees && this.fees.category?.name === name) {
                this.fees.category.name = selectedName;
              }
              this.categories.map((item, index) => {
                if (item._id === categoryId) this.categories.splice(index, 1);
              });
              this.categoryResults = [...this.categories];
            }
            onClose.unsubscribe();
          });
        }
      })
      .catch((err) => this.helperService.showToaster('error', err));

    // const ref = this.dialogService.open(DeleteCategoryDialogComponent, {
    //   width: '1200px',
    //   styleClass: 'add-dialog overflow-initial delete-category-dialog',
    //   showHeader: false,
    //   data: {
    //     selectedCategory : e,
    //     categoryList: this.categoryResults,
    //     type:'fees'
    //   },
    // });
    // const onClose = ref.onClose.subscribe(({ isSuccess, data,selectedName }) => {
    //   if (isSuccess) {
    //     const { categoryId,name } = data.category;
    //     if(this.fees && this.fees.category?.name === name) {this.fees.category.name = selectedName};
    //      this.categories.map( (item, index) => {
    //       if(item._id === categoryId) this.categories.splice(index,1);
    //     });
    //     this.categoryResults = [...this.categories];
    //   }
    //   onClose.unsubscribe();
    // });
  }

  showSuggestions(type?: string) {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  saveCategory({ name }) {
    this.createCategory({
      name,
      type: this.categoryType ? this.categoryType : config.tags.fees,
      color: '',
    });
    this._checkUniqueCategory();
  }

  createCategory(data: any) {
    this.httpService.createTag(data).then(
      (category: any) => {
        if (category) {
          this.helperService.showToaster('success', messages.categoryCreated);
          this.categories.push(category);
          this.fees.category = category;
          this.categoryResults = [...this.categories];
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  onAutoCompleteSelect(event: any, type?: string) {
    if (type === 'tags') {
      this.fees.category = event;
    }
  }

  onClearSuggestion(type: string = '') {
    if (type === 'tags') {
      this.categoryResults = [...this.categories];
    }
  }

  onUpdateItem({ name, color, _id }, type: string) {
    const tag = {
      _id,
      color: color,
      type: this.categoryType ? this.categoryType : type,
      name: name.trim(),
    };

    this.httpService.updateTag(tag).then(
      (data) => {
        for (let i = 0; i < this.categories.length; i++) {
          if (this.categories[i]._id === _id) {
            this.categories[i].name = name;
            break;
          }
        }

        for (let i = 0; i < this.categoryResults.length; i++) {
          if (this.categoryResults[i]._id === _id) {
            this.categoryResults[i].name = name;
            break;
          }
        }

        if (this.fees.category && this.fees.category._id === _id) {
          this.fees.category.name = name;
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  searchSuggestionCategory(query: string, type?: string) {
    this.categoryResults = [];
    query = this.helperService.trimString(query);
    if (type === 'tags') {
      this.categoryResults = this.categories.filter(({ name }) => {
        if (name && new RegExp(`${query}`, 'gi').test(name)) {
          return true;
        } else {
          return false;
        }
      });
    }
  }

  categoryDropdownSelect(type: string, event: any) {
    const payload: any = { salesCode: event.salesCode };

    if (type === 'category' && event.categoryId) {
      if (this.fees.category) {
        delete this.fees?.category?.subCategoryId;
        delete this.fees?.category?.subCategoryName;
        delete this.fees?.category?.subSubCategoryId;
        delete this.fees?.category?.subSubCategoryName;
      }
      this.getSubCategories(event);
      this.subCategoriesSuggestions = [];
      this.subCategoriesSuggestionsResults = [];
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = event;
    }

    if (type === 'subCategory' && event.subCategoryId) {
      delete this.fees?.category?.subSubCategoryId;
      delete this.fees?.category?.subSubCategoryName;
      this.getSubSubCategories(this.fees.category, event);
      this.subSubCategoriesSuggestions = [];
      this.subSubCategoriesSuggestionsResults = [];
      payload.category = {
        categoryId: this.fees.category.categoryId,
        categoryName: this.fees.category.categoryName,
      };
      payload.subCategory = event;
    }

    if (type === 'subSubCategory' && event?.subSubCategoryId) {
      payload.category = {
        categoryId: this.fees.category.categoryId,
        categoryName: this.fees.category.categoryName,
      };
      payload.subCategory = {
        subCategoryId: this.fees.category.subCategoryId,
        subCategoryName: this.fees.category.subCategoryName,
      };
      payload.subSubCategory = event;
    }

    this.onSelectCategory(payload);
  }

  openConfirmationDialog(salesCode: any) {
    let title: string = 'Confirmation';
    let message: string =
      'Updating the item classification will also auto-update the Sales Code based on the new item classification. If a Sales Code was previously assigned to this item, it will be replaced with the new sales code. Are you sure you want to proceed?';
    const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
      width: '30%',
      styleClass: 'small-heading-dialog',
      showHeader: false,
      data: {
        styleClassHeading: 'font-18 font-700',
        title: title,
        message: message,
        button: {
          success: { title: 'Proceed' },
          cancel: { title: 'Cancel' },
        },
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess }) => {
      if (isSuccess) {
        this.fees.salesCode = salesCode;
        //this.salesCodeOverideConfirm = true;
      }
      onClose.unsubscribe();
    });
  }

  onSelectCategory(event: any) {
    const { category, salesCode, isAutoAssign } = this.helperService.onCategorySelect(event, this.fees.salesCode?.salesCodeId);

    this.fees.category = category;
    if (this.fees.salesCode?.salesCodeId && salesCode?.salesCodeId !== this.fees.salesCode?.salesCodeId) {
      this.openConfirmationDialog(salesCode);
    } else {
      this.fees.salesCode = salesCode;
    }

    this.isAutoAssign = isAutoAssign;

    this.subCategoriesSuggestions = [];
    this.subCategoriesSuggestionsResults = [];
    this.subSubCategoriesSuggestions = [];
    this.subSubCategoriesSuggestionsResults = [];
  }

  getAllCategories() {
    const query: any = { itemType: 'hazmatFee' };
    this.loader.category = true;
    // if (this.query) query.searchTerm = encodeURI(this.query);
    this.httpService
      .getPricingCategories(query)
      .then((res: any) => {
        this.categoriesSuggestions = res.categories;
        this.categoriesSuggestionsResults = this.helperService.deepCopy(this.categoriesSuggestions);
      })
      .finally(() => {
        this.loader.category = false;
      });
  }

  getSubCategories(item) {
    this.loader.subCategory = true;
    this.httpService
      .getPricingSubCategories(item.categoryId, 'hazmatFee')
      .then((res: any) => {
        if (res && res.subCategories?.length) {
          this.subCategoriesSuggestions = res.subCategories;
          this.subCategoriesSuggestionsResults = this.helperService.deepCopy(this.subCategoriesSuggestions);
        } else {
          this.subCategoriesSuggestions = [];
          this.subCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subCategory = false;
      });
  }

  getSubSubCategories(item, level2) {
    this.loader.subSubCategory = true;
    this.httpService
      .getPricingSubSubCategories(item.categoryId, level2.subCategoryId, 'hazmatFee')
      .then((res: any = {}) => {
        if (res && res.subSubCategories?.length) {
          this.subSubCategoriesSuggestions = res.subSubCategories;
          this.subSubCategoriesSuggestionsResults = this.helperService.deepCopy(this.subSubCategoriesSuggestions);
        } else {
          this.subSubCategoriesSuggestions = [];
          this.subSubCategoriesSuggestionsResults = [];
        }
      })
      .finally(() => {
        this.loader.subSubCategory = false;
      });
  }
}
